import React, {Component} from 'react';
import actions from "@redux/EditableTable/actions";
import {connect} from "react-redux";
import enUS from "antd/lib/locale/en_US";
// import ProTable from "@ant-design/pro-table";
import _ from "lodash";
import Space from "antd/es/space";
import { Button, ConfigProvider, Drawer, Popconfirm, Tooltip } from "antd";
import ResizableProTable from "@components/Table/ResizableProTable";

import {defaultActionRender} from "@ant-design/pro-utils/es/useEditableArray";
import ID from "@components/UUID";
import ColumnSetting from "@ant-design/pro-table/es/components/ColumnSetting";
import {CloseOutlined, DeleteOutlined, SaveOutlined, SettingOutlined} from "@ant-design/icons";
import PermissionControl from "@components/Permission/Permission";
import { buildProTableColumnsPersistenceKey } from "../../../../utils/proTablePersistenceKey";

class FunctionTestingTableContent extends Component {

    actionRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            isImportCSVModal: false,
            isNewModalOpen: false,
            searchString: null,
            filter_dates: [null, null],
            editableKeys: [],
            visible: false,
            isOutSideVisible: false,
            data: [],
            valueChanged: false,
            newValues: [],
            open: true,
            selectedRowKeys: [],
            selectedRows: []
        }

        this.box = React.createRef();
    }

    componentDidMount() {

    }


    componentWillReceiveProps(nextProps) {

    }


    deleteRecord = async (e) => {
        let result = await this.props.deleteRecord(e);
        this.actionRef.current.reload();

    }


    handOnlineSave = async (key, row) => {

        let keys = this.state.data.map(e => e.id)
        let result;
        // console.log('handOnlineSave', keys, key, row, keys.includes(key))
        if (!keys.includes(key)) {
            // console.log('row', row)
            result = await this.props.createRecords(row);
        } else {
            result = await this.props.handOnlineSave(key, row);
        }

        this.setState({
            valueChanged: false
        }, function () {
            this.actionRef.current.reload();
        })

        return result
    }

    createRecords = async (e) => {
        let result = await this.props.createRecords(e);
        this.actionRef.current.reload();
    }

    handleSaveComment = async (key, row) => {
        let result;
        result = await this.props.handOnlineSave(key, row);
        // console.log('handOnlineSave', result);
    }

    deleteSelected = async (e, body) => {
        let result = await this.props.bulkDelete(body)
        // console.log('delete', result)
        this.actionRef.current.reload();
        this.actionRef.current.clearSelected();
        this.setState({
            visible: false
        })
    }

    handleFresh = (e) => {
        // console.log('refresh')
        this.props.handleGlobalSearch('')
        this.setState({
            searchString: null
        }, function () {
            this.actionRef.current.reload();
        })

    }

    refresh = (needRequest = true) => {
        this.setState({
            needRequest,
        }, this.actionRef.current.reload)
    };

    formRefCallback = (formRef) => {

        this.props.getFormRef(formRef);
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows: selectedRows || [], editableKeys: [] });
    };

    handleConfirmCancel = () => {
        this.setState({ visible: false });
    };

    resolveRowsForBulkActions = (rowIds, selectedRows) => {
        let rows = (selectedRows || []).filter((r) => r != null);
        const dataSource = this.state.data || [];
        if (!rows.length && (rowIds || []).length) {
            rows = (rowIds || [])
                .map((id) => dataSource.find((r) => r != null && r.id == id))
                .filter((r) => r != null);
        }
        return rows;
    };

    buildToolBarRender = (columns) => () => {
        const columnSettingsSlot = (
            <ColumnSetting columns={columns} checkedReset>
                <Button
                    type="default"
                    shape="circle"
                    className="table-page-header-icon-btn"
                    icon={<SettingOutlined/>}
                    aria-label="Column settings"
                />
            </ColumnSetting>
        );
        const { pageHeader } = this.props;
        if (pageHeader == null || pageHeader === "" || pageHeader === false) {
            return (
                <div className="table-toolbar-column-only">
                    {columnSettingsSlot}
                </div>
            );
        }
        if (React.isValidElement(pageHeader)) {
            return React.cloneElement(pageHeader, {
                endToolbarSlot: columnSettingsSlot,
            });
        }
        return (
            <>
                {pageHeader}
                {columnSettingsSlot}
            </>
        );
    };

    cleanBulkSelection = () => {
        if (typeof this.actionRef.current?.clearSelected === "function") {
            this.actionRef.current.clearSelected();
        }
    };

    renderFloatingBulkActionsBar = () => {
        const selectedRowKeys = this.state.selectedRowKeys;
        if (!selectedRowKeys || selectedRowKeys.length === 0) {
            return null;
        }
        const rows = this.resolveRowsForBulkActions(
            selectedRowKeys,
            this.state.selectedRows
        );
        return (
            <div
                className="table-bulk-floating-bar"
                role="toolbar"
                aria-label="Bulk actions for selected rows"
            >
                <Space size={10} align="center" wrap className="table-bulk-floating-bar-inner">
                    <span className="table-bulk-floating-bar-count">
                        <span className="table-bulk-floating-bar-count-label">Selected</span>
                        <span className="table-bulk-floating-bar-count-num">
                            {selectedRowKeys.length}
                        </span>
                        <Tooltip title="Clear selection">
                            <Button
                                type="text"
                                size="small"
                                className="table-bulk-floating-bar-clear"
                                icon={<CloseOutlined />}
                                onClick={this.cleanBulkSelection}
                                aria-label="Clear selection"
                            />
                        </Tooltip>
                    </span>
                    <Popconfirm
                        title="Delete the selected records?"
                        visible={this.state.visible}
                        onConfirm={() => this.deleteSelected(null, rows)}
                        onCancel={() => this.handleConfirmCancel()}
                    >
                        <PermissionControl
                            allowedPermissions={'3:' + this.props.columnProps?.name}
                        >
                            <Tooltip title="Delete selected">
                                <span>
                                    <Button
                                        type="default"
                                        danger
                                        shape="circle"
                                        className="table-bulk-floating-btn"
                                        icon={<DeleteOutlined />}
                                        onClick={() => this.showPopconfirm()}
                                        aria-label="Delete selected"
                                    />
                                </span>
                            </Tooltip>
                        </PermissionControl>
                    </Popconfirm>
                </Space>
            </div>
        );
    };


    setEditableRowKeys = (e, row) => {
        this.setState({
            editableKeys: e
        })
    }

    handleValueClicked = (record, recordList) => {
        if (!record || !(this.state.editableKeys || []).some((k) => k == record.id)) {
            return;
        }
        let newValuesdata = this.state.data;
        let newValues = record;
        let oldValues = this.state.data.filter((e) => e.id === record.id)[0];
        let result = false;
        if (oldValues) {
            for (let i = 0; i < this.state.data.length; i++) {
                if (this.state.data[i].id === record.id) {
                    newValuesdata[i] = record;
                }
            }
            for (let i = 0; i < Object.keys(oldValues).length; i++) {
                for (let j = 0; j < Object.keys(newValues).length; j++) {
                    if (
                        oldValues[Object.keys(oldValues)[i]] ===
                            newValues[Object.keys(newValues)[j]] &&
                        Object.keys(oldValues)[i] === Object.keys(newValues)[j]
                    ) {
                        result = true;
                    }
                }
            }
        } else {
            let oldValuesData = this.state.data.filter((e) => e.id !== record.id);
            newValuesdata = [...oldValuesData, record];
            if (
                this.state.data.length > 0 &&
                this.state.data.filter((e) => e.id === record.id).length === 0
            ) {
                result = true;
            }
        }
        this.setState({
            valueChanged: result,
            newValues: record,
        });
    };

    showPopconfirm = (e) => {
        this.setState({
            visible: true
        })
    }
    render() {

        let columns = this.props.columns;
        if (this.props.relatedList) {
            columns = columns.filter(e => e.title !== 'Operation')
        }

        const columnsPersistenceKey = buildProTableColumnsPersistenceKey({
            columnProps: this.props.columnProps,
            relatedList: this.props.relatedList,
            relatedObject: this.props.relatedObject,
            relatedId: this.props.relatedId,
            columns,
        });

        let params = [
            this.state.searchString,
        ]

        return (
            <>
                {this.state.open ? <div className={'editable'} ref={this.box}>
                    <ConfigProvider locale={enUS}>

                            <ResizableProTable
                                key={'FunctionTestingTableContent_editable' + ID}
                                size="middle"
                                columnsState={{
                                    persistenceKey: columnsPersistenceKey,
                                    persistenceType: 'localStorage',
                                    defaultValue: this.props.defaultDisplayColumns,
                                    onChange: (e) => {
                                        console.log(e)
                                    }
                                }}

                                toolBarRender={this.buildToolBarRender(columns)}
                                tableAlertRender={false}
                                options={{
                                    density: false,
                                    reload: false,
                                    setting: false,
                                }}
                                expandedRowRender={this.props.expandedRowRender}
                                editable={{
                                    type: 'multiple',
                                    formProps: { size: 'small' },
                                    onDelete: this.deleteRecord,
                                    deletePopconfirmMessage: 'delete this row',
                                    onSave: (keys, row) => this.handOnlineSave(keys, row),
                                    editableKeys: this.state.editableKeys,
                                    onChange: this.setEditableRowKeys,
                                    onlyAddOneLineAlertMessage: 'only add one line',
                                    actionRender: (row, config) => {
                                        const configLocal = {...config};
                                        configLocal.saveText = <SaveOutlined className="editable-action-icon" />;
                                        configLocal.deleteText = <DeleteOutlined className="editable-action-icon" />;
                                        configLocal.cancelText = (
                                            <CloseOutlined className="editable-action-icon" />
                                        );
                                        const doms = defaultActionRender(row, configLocal);
                                        return (
                                            <Space size={8} className="editable-table-row-actions" wrap={false}>
                                                {doms}
                                            </Space>
                                        );
                                    },
                                    onValuesChange: (record, recordList) => this.handleValueClicked(record, recordList)
                                }}
                                value={this.state.data}
                                showSorterTooltip={false}
                                recordCreatorProps={false}
                                rowClassName={(record) => {
                                    let rowClass = '';
                                    if (
                                        this.props.selected_row === record.id ||
                                        (_.get(record, 'facility_id') && this.props.selected_row === _.get(record, 'facility_id'))
                                    ) {
                                        rowClass += ' selected_row';
                                    }
                                    return rowClass;
                                }}
                                columns={columns}
                                actionRef={this.actionRef}
                                scroll={this.props.scroll ? this.props.scroll : {x: 800}}
                                params={params}
                                postData={(data) => {
                                    this.props.getRecord(data)
                                    return data
                                }}
                                request={async (params = {}, sort = {}, filter) => {
                                    console.log("params", params, ' sort', sort, 'filter: ', filter);

                                    let query = 'page=' + params.current + '&page_size=' + params.pageSize + '&';

                                    for (const [key, value] of Object.entries(sort)) {
                                        if (value === 'descend') {
                                            query += "ordering=-" + key + "&";
                                        } else if (value === 'ascend') {
                                            query += "ordering=" + key + "&";
                                        }
                                    }

                                    if (this.props.relatedList && this.props.relatedId && this.props.relatedObject) {
                                        query += '&relatedId=' + this.props.relatedId + '&relatedObject=' + this.props.relatedObject;
                                    }
                                    let result = await this.props.handleFilter(query);
                                    let result_data = _.get(result, 'data', []);

                                    this.setState({
                                        data: result_data,
                                        editableKeys: [],
                                    })

                                    return result
                                }}
                                rowSelection={
                                    {
                                        selections: false,
                                        onChange: this.onSelectChange,
                                    }}
                                rowKey="id"
                                search={false}
                                pagination={{
                                    showSizeChanger: true,
                                    pageSizeOptions: [10, 20, 50, 100, 1000],
                                    showQuickJumper: true,
                                    showTotal: (total, range) => (
                                        <div>{`Showing ${range[0]}-${range[1]} of ${total} total items`}</div>
                                    ),
                                }}

                                onRow={(record, recordIndex) => {
                                    // when each row cell is clicked
                                    console.log('selected', record)
                                    if (!this.props.permission[this.props.columnProps.name] > 1 || this.props.Role === '2.2' || this.props.Role === '4.0') {
                                        return null
                                    } else {
                                        return {

                                            onDoubleClick: event => {
                                                this.props.handleDetailDrawer(true, record.id)
                                                // this.renderDrawer(record, {'id': record.id})
                                            }
                                        }
                                    }


                                }}
                            />
                            {this.renderFloatingBulkActionsBar()}

                    </ConfigProvider>
                </div> : ''}
            </>
        );
    }
}


const mapStateToProps = state => {
    return {
        facility_id: _.get(state.Facility, 'selected.Id'),
        Role: _.get(state, 'Auth.role') ? Object.keys(_.get(state, 'Auth.role'))[0] : null,
        permission: state.Auth.permission,
    }
}
const mapDispatchToProps = dispatch => {
    return {

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {forwardRef: true}
)(FunctionTestingTableContent);
